import { bold, brightCyan, dim, green } from '../../core/color.js';
import type { PluginInstall } from '../../core/kernel.js';

const bullet = dim('-');
const cmd = brightCyan;
const section = green;

const CONTENT: string[] = [
  '',
  bold('joaquin pinillos'),
  dim('software engineer, drawn to the low level'),
  '',
  section('background'),
  `${bullet} full-stack, tooling, infrastructure`,
  `${bullet} since 2004, from assembly to the cloud`,
  '',
  section('current focus'),
  `${bullet} platform development at forge (startup)`,
  `${bullet} tool development`,
  '',
  section('the pull'),
  `${bullet} systems`,
  `${bullet} security`,
  '',
  section('approach'),
  `${bullet} understanding abstractions by breaking them`,
  `${bullet} learning by building small experiments`,
  '',
  section('reach'),
  `${bullet} github:   [github.com/jazho76](https://github.com/jazho76)`,
  `${bullet} linkedin: [linkedin.com/in/joaquin-pinillos](https://www.linkedin.com/in/joaquin-pinillos-31b8a0158/)`,
  `${bullet} email:    [hello@jpinillos.dev](mailto:hello@jpinillos.dev)`,
  '',
  section('tip'),
  `${bullet} try: ${cmd('about')}, ${cmd('projects')}, ${cmd('help')}`,
  '',
  dim(
    'source code for this terminal lives at [github.com/jazho76/shellwebsite](https://github.com/jazho76/shellwebsite)'
  ),
];

const install: PluginInstall = kernel => {
  kernel.installExecutable('/bin/welcome', {
    describe: 'portfolio overview',
    exec(ctx) {
      ctx.stdout(CONTENT.join('\n') + '\n');
      return 0;
    },
  });
};

export default install;
